export default "__VITE_ASSET__CtOpfkMi__"